import { render, staticRenderFns } from "./EditChannel.vue?vue&type=template&id=6a3f344f"
import script from "./EditChannel.vue?vue&type=script&lang=js"
export * from "./EditChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports